export const AMAZONISATION_GENERAL_TRACKING_ID =
  'amazonisation_account_helpcentre_general'
